import { generateClassName } from '@klv/shared/utils/functions';

import Typography from '@klv/atoms/typography';
import type { IProductCard } from '@klv/molecules/product-card/types';
import { ProductsCardFullWidth } from '@klv/molecules/products-card-full-width';
import { ProductCard }  from '@klv/molecules/product-card';
import FadeInUp from '@klv/utils/fade-in-up';

import * as styles from './styles/products.module.scss';
import cardData from './static/data';
import { getCardOverrides, getCDPCardOverrides } from './utils';

import type { IProducts } from './types';
import type { IProductsCardFullWidth } from '@klv/molecules/products-card-full-width/types';

export const Products = ({
  cardOverrides,
  customPadding,
  gradientHeadline,
  productVersion,
}: IProducts) => {
  // This logic will change as we get more variations
  if (productVersion == 'fr' || productVersion === 'none') {
    return <></>;
  }

  const cdpOverrides: IProductsCardFullWidth = getCDPCardOverrides(cardOverrides, cardData[productVersion].cdpCards);
  
  return (
    <div className={styles.products}>
      <div className={generateClassName([
        'grid',
        styles.wrapper,
        `${customPadding.customPaddingBottom}PaddingBottom`,
        `${customPadding.customPaddingTop}PaddingTop`,
      ])}>
        <FadeInUp>
          <div className={generateClassName(['grid'])}>
            {gradientHeadline?.headline && (
              <Typography
                className={styles.styledHeadline}
                as= 'h2'
                variant='h2'
                dangerouslySetInnerHTML={{ __html: gradientHeadline.headline }}
              />
            )} 
          </div>
          </FadeInUp>
          <FadeInUp threshold={.01}>
            <div className={generateClassName(['grid', styles.productContainer])}>
              {productVersion && getCardOverrides(cardOverrides, cardData[productVersion].productCards).map((card: IProductCard) => <ProductCard key={card.buttonText} {...cardOverrides} {...card} />)}
            </div>
          </FadeInUp>
          <FadeInUp threshold={.01}>
            <svg className={styles.arrowsSvg} id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 942.99 70">
              <path d="m471.96,61.55c-4.65-12.58-16.76-21.55-30.96-21.55H44.99C25.22,40,8.79,25.64,5.57,6.78" fill="none" stroke="#dfd4c0" strokeWidth="2"/>
              <path d="m362.99,40h-18c-19.39,0-35.48-14.15-38.49-32.69" fill="none" stroke="#dfd4c0" strokeWidth="2"/>
              <path d="m471.03,61.55c4.65-12.58,16.76-21.55,30.96-21.55h396c19.6,0,35.91-14.1,39.34-32.7" fill="none" stroke="#dfd4c0" strokeWidth="2"/>
              <path d="m579.99,40h18c19.39,0,35.48-14.16,38.49-32.7" fill="none" stroke="#dfd4c0" strokeWidth="2"/>
              <circle cx="83.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="106.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="190.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="291.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="496.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="309.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="595.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="724.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="742.99" cy="40" r="6" fill="#c9aef1"/>
              <circle cx="822.99" cy="40" r="6" fill="#c9aef1"/>
              <path d="m471.49,70l-6.49-11.25h12.99l-6.49,11.25Z" fill="#dfd4c0"/>
              <path d="m307.49,0l6.49,11.25h-12.99l6.49-11.25Z" fill="#dfd4c0"/>
              <path d="m635.49,0l6.49,11.25h-12.99l6.49-11.25Z" fill="#dfd4c0"/>
              <path d="m936.49,0l6.5,11.25h-13l6.5-11.25Z" fill="#dfd4c0"/>
              <path d="m6.49,0l6.49,11.25H0L6.49,0Z" fill="#dfd4c0"/>
            </svg>
          </FadeInUp>
          <FadeInUp threshold={.01}>
            {productVersion && <ProductsCardFullWidth { ...cdpOverrides}/>}
          </FadeInUp>
        </div>
        </div>
  );
};
